<template>
  <div class="c30-wrap">
    <section ref="print">
      <div class="report">
        <div class="mytitle">
          <ul>
            <li>
              <span>打印日期：</span>
              <span>{{ nowday }}</span>
            </li>
            <li>
              <span>打印时间：</span>
              <span>{{ nowtime }}</span>
            </li>
            <li>
              <span>酒店日期：</span>
              <span>{{ $parent.hotelInfo.dhoteltime }}</span>
            </li>
          </ul>
          <ul
            style="display: flex; flex-direction: column; align-items: center"
          >
            <li>
              <span></span>
              <span>{{ $parent.hotelInfo.cname }}</span>
            </li>
            <li>
              <span></span>
              <span>{{ $parent.bbmc }}</span>
            </li>
            <li>
              <span>查询日期：</span>
              <span>
                {{ this.$moment(this.startDate).format("YYYY-MM-DD") }}
              </span>
              <span v-if="$parent.endTimeShow">
                至{{ this.$moment(this.endDate).format("YYYY-MM-DD") }}
              </span>
            </li>
          </ul>
          <ul
            style="display: flex; flex-direction: column; align-items: flex-end"
          >
            <li>
              <span>操作员:</span>
              <span>{{ $parent.userInfo.cname }}</span>
            </li>
            <!-- <li>
            <span>总页数:</span>
            <span>{{pagecount}}</span>
        </li>-->
            <li v-if="$parent.datacount > 0">
              <span>总条数:</span>
              <span>{{ $parent.datacount }}条</span>
            </li>
          </ul>
        </div>
        <div class="c30-container">
          <div class="PreArrivalItem">
            <div  class="zhanghao">账号</div>
            <div class="xingming">姓名</div>
            <div class="fangxing">客房类型</div>
            <div class="fanghao">房号</div>
            <div class="fangjia" style="text-align:right">房价</div>
            <div  class="shijian2">抵店时间</div>
            <div class="xingming">悬单天数</div>
            <!-- <div class="fangjia">预授权</div> -->
            <div class="shijian">离店时间</div>
            <div class="fangxing" style="text-align:right">押金（1）</div>
            <div class="fangxing" style="text-align:right">消费（2）</div>
            <div class="fangxing" style="text-align:right">余额（1-2）</div>
            <div style="text-align:left;padding-left:10px;flex:1">担保人/备注</div>
          </div>
          <div v-for="item in list" class="list">
            <div v-for="billItem in item.billList" class="PreArrivalItem">
              <div class="zhanghao">{{ billItem.accNo }}</div>
              <div class="xingming">{{ billItem.guestName }}</div>
              <div class="fangxing">{{ billItem.roomType }}</div>
              <div  class="fanghao">{{ billItem.roomNo }}</div>
              <div class="fangjia" style="text-align:right">{{ $parent.curreny(billItem.roomRate) }}</div>
              <div class="shijian2">{{ billItem.arrival }} {{ billItem.arrTime }}</div>
              <div class="xingming">{{ billItem.days }}</div>
              <!-- <div class="fangjia">{{ billItem }}</div> -->
              <div class="shijian">{{ billItem.checkOut }}</div>
              <div class="fangxing" style="text-align:right">{{ $parent.curreny(billItem.earnest) }}</div>
              <div class="fangxing" style="text-align:right">{{$parent.curreny(billItem.revTotal) }}</div>
              <div class="fangxing" style="text-align:right">{{$parent.curreny(billItem.earnest-billItem.revTotal)}}</div>
              <div style="text-align:left;padding-left:10px;flex:1">{{ billItem.remark }}</div>
            </div>
            <div class="c30-foot">
              <div class="c30-foot-con1">
                <div style="width: 50%">悬单时间》=50小计：</div>
                <div>条记录</div>
              </div>
              <div>应收金额</div>
              <div style="text-align:right">{{ item.allAmount}}</div>
            </div>
          </div>

          <div class="c30-foot" style="border: none">
            <div class="c30-foot-con1">
              <div style="width: 50%">合计：</div>
              <div>{{ totalLength }}条记录</div>
            </div>
            <div>应收金额</div>
            <div style="text-align:right">{{ total }}</div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { postRequest, getRequest } from "@/api/api1.js";
export default {
  data() {
    return {
      list: [],
      comeIn: [],
      goBack: [],
      obj: {
        dingjin: 0,
        xiaofei: 0,
        yue: 0,
        jine: 0,
      },
      obj2: {
        dingjin: 0,
        xiaofei: 0,
        yue: 0,
        jine: 0,
      },
      total: null,
      room: "",
      record: "",
      totalLength: 0,
      nowday:"",
      nowtime: "",
      startDate: "",
      endDate: ""
    };
  },
  created() {
    this.$parent.closeshow();
    this.$parent.bbmc = "C30前台当前所有悬单报表";
    this.$parent.startDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.$parent.endDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.$parent.closeshow();
    this.$parent.chaxunvib = true;
    this.getData();
  },
  methods: {
     doserach(){
      this.getData();
    },
    dodayin() {
      this.$print(this.$refs.print);
    },
    getData() {
      this.total = 0;
      let that = this;
      let loadingInstance = this.$loading({ text: "正在查询..." });
      getRequest("/report/C30").then((res) => {

        this.$nextTick(() => {
          loadingInstance.close();
        }); //不回调
        if (res.status == 200) {
          res.data.forEach((item) => {
            item.billList.forEach((billItem) => {
              billItem.checkOut = this.$moment(billItem.checkOut).format(
                "YYYY-MM-DD "
              );
            });
            this.totalLength = item.total;
          });
          this.list = res.data;
          if(res.data[0]&&res.data[0].billList){
              this.$store.state.preArrivalList =res.data[0].billList;
          }

          this.$store.state.preArrivalName = "C30前台当前所有悬单报表";
          this.list.forEach((item) => {
            this.total += item.allAmount;
          });
          this.nowday= this.$moment(new Date()).format('YYYY-MM-DD');
          this.nowtime= this.$moment(new Date()).format('HH:mm:ss');
          this.startDate= this.$parent.startDate;
          this.endDate= this.$parent.endDate;
        } else {
          this.$mymessage({
            content: res.code,
            type: "error",
            time: 3000,
            hasClose: true,
          });
        }
      });
    },
    doserach() {
      if (new Date(this.$parent.startDate) <= new Date(this.$parent.endDate)) {
        this.getData();
      } else {
        this.$mymessage({
          content: "截止日期必须大于开始日期",
          type: "error",
          time: 3000,
          hasClose: true,
        });
      }
    },
    caculate() {
      this.caculate2(this.comeIn, "obj");
      this.caculate2(this.goBack, "obj2");
    },
    caculate2(list, obj) {
      let item = {
        dingjin: 0,
        xiaofei: 0,
        yue: 0,
        jine: 0,
      };
      if (list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          item.dingjin += parseFloat(list[i].earnest);
          item.xiaofei += parseFloat(list[i].consumeAmount);
        }

        item.yue = parseFloat(item.dingjin) - parseFloat(item.xiaofei);
        if (obj == "obj") {
          item.jine = parseFloat(item.xiaofei) - parseFloat(item.dingjin);
        } else {
          item.jine = item.yue;
        }
        this[obj] = item;
      }
    },
    // curreny(data) {
    //   if (data != null && data != undefined) {
    //     data = Number(data).toFixed(2);
    //     return data;
    //   }
    // },
  },
};
</script>

<style scoped>
.c30-wrap {
  width: 100%;
  padding: 20px;
}
.c30-head > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.c30-head > div div {
  flex: 1;
  line-height: 22px;
  font-size: 14px;
}
.c30-head > div div:nth-child(2) {
  text-align: center;
}
.c30-head > div div:nth-child(3) {
  text-align: right;
}

.list {
  display: flex;
  flex-direction: column;
}
.title {
  display: flex;
}
.list > div {
  display: flex;
}
.c30-container > div:last-child {
  /* border-bottom: 1px solid black; */
  padding-bottom: 3px;
}

.title {
  line-height: 24px;
  border-bottom: 1px solid black;
  /* border-top: 1px solid black; */
  font-size: 14px;
  font-weight: 400;
  padding: 0;
}

.c30-foot {
  display: flex;
  font-size: 14px;
  align-items: center;
  width: 100%;
  border-bottom: 2px solid black;
  font-weight: 500;
  font-weight: 600;
}
.c30-foot .c30-foot-con1 {
  display: flex;
  align-items: center;
  width: 73% !important;
  padding-left: 15%;
}
.c30-foot .c30-foot-con1 > div {
  display: flex;
  width: 20%;
}
.c30-foot > div {
  width: 7% !important;
  text-align: center;
}
.mytitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px !important;
  line-height: 24px;
  margin-bottom: 1em;
}
</style>